// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1qOeb","colMin":"styles_colMin__19f2J","colCheckbox":"styles_colCheckbox__2toe0"};